/**
 * Solicitar ingreso
 *
 */
import React from 'react'
import { Button, DatePicker, Modal, Input, Row, Popconfirm } from 'antd'
import moment from 'moment'
import Api from '../../../Api'
import Exception from '../../../Exception'

/**
 *
 */
export default class EntregaFormModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      search: '',
      form: this.defaultForm(),
    }
  }

  /**
   * defaultForm
   */
  defaultForm = () => ({
    iId: null,
    dFechaEntrega: moment().format('YYYY-MM-DD'),
    sReferencia: '',
  })

  /**
   * setFormValue
   *
   * @param {String} key
   * @param {Any} value
   */
  setFormValue = (key, value) => {
    this.setState({
      form: {
        ...JSON.parse(JSON.stringify(this.state.form)),
        [key]: value
      }
    })
  }

  /**
   * load
   */
  load = (id) => {
    this.setState({
      loading: true,
      visible: true,
    })

    const query = {
      __returnType: 'one',
      model: 'ComProveedorEntrega',
      attributes: Object.keys(this.defaultForm()),
      where: { iId: id },
    }

    Api.query(query)
      .then(({ data }) => {
        this.setState({
          loading: false,
          form: {
            ...this.defaultForm(),
            ...data,
          }
        })
      })
      .catch(error => {
        Exception.load(error).show()
        this.setState({ loading: false })
      })
  }

  /**
   * saveValues
   */
  saveValues = (data) => {
    const id = data.iId

    const mutation = { model: 'ComProveedorEntrega', id, values: data }
    const request = Api.post('/kernel/mutator', mutation)

    request
      .then(response => {
        this.setState({ loading: false, visible: false })

        if (typeof this.props.onCreate === 'function') {
          this.props.onCreate(response.data)
        }
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * onCancel
   */
  onCancel = () => {
    this.setState({
      visible: false,
    })
  }

  /**
   * onDelete
   */
  onDelete = () => {
    this.saveValues({
      iId: this.state.form.iId,
      iActivo: false
    })
  }

  /**
   * showModal()
   */
  showModal() {
    this.setState({
      loading: false,
      visible: true,
      search: '',
      form: this.defaultForm(),
    })
  }

  /**
   * onSave
   */
  onSave = () => {
    this.saveValues(JSON.parse(JSON.stringify(this.state.form)))
  }

  /**
   * render
   */
  render() {
    return (
      <Modal
        title='Crear entrega'
        style={{ maxWidth: 600, top: 20 }}
        visible={this.state.visible}
        onOk={this.onSave}
        onCancel={this.onCancel}
        footer={[
          !this.state.form.iId ? null : (
            <Popconfirm key='guardar' title='Eliminar entrega?' onConfirm={this.onDelete}>
              <Button key='Eliminar' children='Eliminar' type='danger' />
            </Popconfirm>
          ),
          <Popconfirm key='guardar' title='Crear entrega?' onConfirm={this.onSave}>
            <Button type='primary' loading={this.state.loading} children='Aceptar' />
          </Popconfirm>,
        ]}>

        <Row style={styles.row}>
          <label>FECHA DE LLEGADA ESTIMADA</label>
          <div>
            <DatePicker
              value={this.state.form.dFechaEntrega ? moment(this.state.form.dFechaEntrega, 'YYYY-MM-DD') : null}
              onChange={date => date ? this.setFormValue('dFechaEntrega', date.format('YYYY-MM-DD')) : undefined}
            />
          </div>
        </Row>

        <Row style={styles.row}>
          <label>REFERENCIA (# FACTURA)</label>
          <Input
            value={this.state.form.sReferencia}
            onChange={e => this.setFormValue('sReferencia', e.target.value)}
          />
        </Row>
      </Modal>
    )
  }
}

const styles = {
  row: {
    marginBottom: 10,
  }
}
